import Raven from 'raven-js';
export function executeAfterPromise(promise, callback) {
  promise.catch(err => {
    Raven.captureException(err);
  }).finally(callback);
}